import React, { useContext } from "react";

import { observer } from "mobx-react";
import Image from "next/legacy/image";
import Link from "next/link";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import Button from "../Button/Button";

const StyledVacancyThumbnail = styled.div`
  height: 0;
  padding-top: 70%;
  position: relative;
`;

const StyledOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
`;

const StyledCardWrapper = styled.div`
  cursor: pointer;
`;

function ThumbnailItem(props) {
  const { vacancy } = props;
  const { rolesStore } = useStores();
  const { thumbnail, useComanyLogoAsThumbnail } = useContext(ComponentContext);
  const vacancyRole = rolesStore.roles.find(
    (role) => role.roleName === vacancy.category
  );

  const locationString = [
    vacancy?.company.name,
    vacancy?.location?.city,
    vacancy?.location?.county,
  ]
    .filter(Boolean)
    .join(", ");

  const href = `/job/${vacancy.id}`;

  let thumbnailUrl = vacancyRole?.thumbnail?.url || thumbnail?.url;

  if (useComanyLogoAsThumbnail && vacancy?.company?.logoUrlFull) {
    thumbnailUrl = vacancy?.company?.logoUrlFull;
  }

  return (
    <Link href={href} passHref legacyBehavior>
      <StyledCardWrapper className="d-flex flex-column h-100">
        <div className="bg-white">
          <StyledVacancyThumbnail className="position-relative">
            {thumbnailUrl && (
              <Image
                alt={vacancy.jobTitle}
                className="position-absolute t-0"
                layout="fill"
                objectFit="cover"
                src={thumbnailUrl}
              />
            )}
            <StyledOverlay className="position-absolute top-0 w-100 bottom-0 d-flex align-items-center justify-content-center">
              <h3 className="text-center mb-0 text-white fw-bold h2 text-uppercase">
                {vacancy.jobTitle}
              </h3>
            </StyledOverlay>
          </StyledVacancyThumbnail>
        </div>
        <div className="bg-white p-4 flex-grow-1 d-flex flex-column">
          <div className="pb-5 fw-bold fs-5">
            <p>{locationString}</p>
            <p>{vacancy.remuneration?.description}</p>
          </div>
          <div className="d-flex justify-content-center mt-auto">
            <Button className="w-50 mx-auto d-flex justify-content-center align-items-center">
              READ MORE
            </Button>
          </div>
        </div>
      </StyledCardWrapper>
    </Link>
  );
}

export default observer(ThumbnailItem);

ThumbnailItem.propTypes = {
  vacancy: PropTypes.shape({
    category: PropTypes.string,
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
    hoursType: PropTypes.string,
    id: PropTypes.number,
    jobTitle: PropTypes.string,
    location: PropTypes.shape({
      city: PropTypes.string,
    }),
    remuneration: PropTypes.shape({
      description: PropTypes.string,
    }),
  }),
};

ThumbnailItem.defaultProps = {
  vacancy: {},
};
